<template>
  <div
    v-loading.fullscreen="allLoading"
    :element-loading-text="$t('page.content.processWait')"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.2)"
  >
    <div class="ccui-app-container-detail2">
      <div ref="detailBody" class="ccui-app-container-detail-body">
        <div style="margin-bottom:10px" v-if="isPassFlag">
          <!-- 淘汰 已不能查看 -->
          <el-alert
            class="alertColor"
            :title="$t('page.content.pleaseWait')"
            type="warning"
            :closable="false"
            show-icon
          >
          </el-alert>
        </div>
        <div>
          <div style="margin-bottom:10px" v-if="flag === '0' || flag == 2">
            <!-- 抱歉，尚未到投标环节 -->
            <!--投标时间未到，投标开始时间为-->
            <el-alert
              class="alertColor"
              :title="
                bidStartTime &&
                new Date(bidStartTime).getTime() < new Date().getTime()
                  ? $t('page.content.thimNot') + bidStartTime
                  : $t('page.content.Noyet')
              "
              type="warning"
              :closable="false"
              show-icon
            >
            </el-alert>
          </div>
          <!-- 已不能查看 -->
          <el-alert
            class="alertColor"
            v-if="bidFlag == 2 && purchaseType != 4"
            :title="$t('page.content.UnableSee')"
            type="warning"
            :closable="false"
            show-icon
          >
          </el-alert>
          <div
            style="margin-bottom:10px"
            v-if="
              flag == 1 && (bidFlag != 2 || (bidFlag == 2 && purchaseType == 4))
            "
          >
            <!-- 本次投标已结束 -->
            <el-alert
              class="alertColor"
              :title="$t('page.content.TimeIsUp1')"
              type="warning"
              :closable="false"
              show-icon
            >
            </el-alert>
          </div>
          <!-- 请您按照报价要求填报报价信息及上传投标文件 -->
          <el-alert
            class="alertColor"
            v-if="(bidFlag == 0 || bidFlag == 1) && flag == 3"
            :title="$t('page.content.requirements')"
            type="warning"
            :closable="false"
            show-icon
          >
          </el-alert>
          <!-- 未投标 -->
          <div
            class="noBuy"
            v-if="
              (flag == 1 || flag == 3) &&
                (bidFlag != 2 || (bidFlag == 2 && purchaseType == 4))
            "
          >
            <el-group-title
              :title="$t('page.content.attention')"
              v-if="purchaseType == 50 || purchaseType == 53"
            >
              <template slot="groupTitle">
                <div
                  class="title"
                  style="overflow:hidden;"
                  v-html="projectText"
                ></div>
              </template>
            </el-group-title>
            <tableBid1
              v-if="purchaseType != 50 && purchaseType != 53 && tableBidFlag"
              ref="tableBid"
              :tableData="tableBid"
              :unit="unit"
              :type="flag == 3 && bidFlag == 0 ? 1 : 0"
            ></tableBid1>
            <!-- 请上传投标文件，大小应该控制在50M内 -->
            <div class="upFile">
              <span :style="{ left: spanWidth + 'px' }">{{
                $t("page.content.message")
              }}</span>
              <!-- 上传投标文件 -->
              <el-group-title
                :title="$t('page.content.upload1')"
                ref="groupTitle"
              >
                <template slot="groupTitle">
                  <attachmentUpload
                    ref="fileTable"
                    :fileData="tableUpData"
                    :type="flag == 3 && bidFlag == 0 ? 1 : 2"
                    :headerMust="true"
                  ></attachmentUpload>
                </template>
              </el-group-title>
            </div>
            <!-- 投标确认 -->
            <el-dialog
              width="500px"
              :title="$t('page.content.bidConfirmation')"
              :visible.sync="dialogTableVisibletextarea"
              center
            >
              <div class="dialogBid">
                <div v-if="purchaseType != 50 && purchaseType != 53">
                  <!-- 投标总金额（元）： -->
                  <p v-for="item in packNameList" :key="item.packId">
                    <span class="item-packName">{{ item.packName }}</span
                    >{{
                      $t("page.content.Totalamount") + "(" + unit + ")"
                    }}：<span style="color:red">{{
                      item.packBidTotalAmt
                    }}</span>
                  </p>
                  <!-- 本次投标总金额（元）： -->
                  <p>
                    {{ $t("page.content.this")
                    }}{{
                      $t("page.content.Totalamount") + "(" + unit + ")"
                    }}：<span style="color:red">{{ total }}</span>
                  </p>
                  <!-- 大写金额：  'CNY-人民币'-->
                  <p v-if="unit == $t('page.content.cnyRmb')">
                    {{ $t("page.content.AmountInWords") }}：<span>{{
                      totalCapitalize
                    }}</span>
                  </p>
                </div>
                <!-- 您是否确认提交？ -->
                <p>{{ $t("page.content.suresubmit") }}</p>
              </div>
              <div slot="footer" class="dialog-footer">
                <el-button
                  size="mini"
                  type="default-mini"
                  @click="dialogTableVisibletextarea = false"
                  >{{ $t("page.content.cancel") }}</el-button
                >
                <!-- 取 消 -->
                <el-button
                  size="mini"
                  type="primary-font-mini"
                  @click="sure"
                  :disabled="btnDisabled"
                  >{{ $t("page.content.sure1") }}</el-button
                >
                <!-- 确 定 -->
              </div>
            </el-dialog>
          </div>
        </div>
      </div>
    </div>
    <div
      class="operate"
      :style="{ width: width }"
      v-if="flag == 3 && bidFlag == 0"
    >
      <!-- 投标 -->
      <el-button type="text" icon="icon-ccui-agree" @click="submit">{{
        $t("page.content.tender")
      }}</el-button>
      <!-- 取消 -->
      <el-button type="text" icon="icon-ccui-disagree" @click="handleCacal">{{
        $t("page.content.cancel")
      }}</el-button>
    </div>
    <div
      class="operate"
      :style="{ width: width }"
      v-if="flag == 3 && bidFlag == 1"
    >
      <!-- 再次上报 -->
      <el-button type="text" icon="icon-ccui-agree" @click="submmitAgain">{{
        $t("page.content.Modification")
      }}</el-button>
      <!-- 撤销投标 -->
      <el-button type="text" icon="icon-ccui-disagree" @click="cacal">{{
        $t("page.content.WithdrawofBid")
      }}</el-button>
    </div>
  </div>
</template>

<script>
import {
  qrySupBidDetail,
  dealSupBidPrice,
  dealSupBidPriceCancel,
  qryBidSchemeProcessStatus,
  queryPurchaseSchemeDetail,
  qrySupBidDetailForFwa,
  dealSupBidPriceForFwa,
  getSystemCurrentTime,
  qrySupPreqtion,
  qrySupTender
} from "@/app/myProjects/api/myProjects.js";
import tableBid1 from "./components/tableBid1";
import attachmentUpload from "@/basa/components/common/attachmentUpload.vue";
import BigNumber from "bignumber.js";
export default {
  inject: ["reload"], // 其他页面注册
  components: {
    attachmentUpload,
    tableBid1
  },
  async mounted() {
    this.width = this.$refs["detailBody"].scrollWidth + "px";
    this.subPackageFlag = JSON.parse(sessionStorage.getItem("subPackageFlag"));
    this.agentId = this.$router.history.current.query.a;
    this.schemeId = sessionStorage.getItem("schemeId");
    this.allLoading = false;
    let params = {
      agentId: this.agentId,
      supCode: sessionStorage.getItem("supCode"),
      schemeId: this.schemeId,
      isShowPageLoading: true
    };
    let res = (await qrySupPreqtion(params)).data.data;
    let eliminateObj = res.sscSupPreqtionBO;
    if (eliminateObj == null) {
      this.isPassFlag = false;
    } else {
      let eliminate = res.sscSupPreqtionBO.passFlag;
      let preStatus = res.sscSupPreqtionBO.preStatus; // =2 表示资格审定已经结束
      this.isPassFlag =
        eliminate === "0" || (eliminate === "" && preStatus === "2");
    }

    if (!this.isPassFlag) {
      this.getState();
    }

    this.timer4 && clearInterval(this.timer4);
    this.timer4 = setInterval(() => {
      this.getCurrentDate();
    }, 1000 * 15);
  },
  activated() {
    this.flagCom = this.$route_query.flagCom ? this.$route_query.flagCom : 1;
  },
  updated() {
    if (this.$refs.groupTitle) {
      this.spanWidth =
        this.$refs.groupTitle.$el.getElementsByClassName("group-title")[0]
          .clientWidth + 20;
    }
  },
  data() {
    return {
      bidStartTime: "",
      agentId: "",
      schemeId: "",
      width: "1000px",
      date3: 0,
      timeId: "",
      subPackageFlag: "",
      projectText: "",
      flagCom: 1, //是否竞争性
      flag: "", //0 未开始 1 已结束 2准备中 3投标中
      tableUpData: [], //附件信息
      tableBid: [], //包件信息
      tableList: [], //包件信息
      tableListNo: [], //不报价的包件信息
      dialogTableVisibletextarea: false,
      packNameList: [],
      total: 0,
      bidFlag: 0, //0-未报价，1-已报价，2-已不能查看，3-上一轮报价已结束 5已结束
      totalCapitalize: "",
      bidPriceId: "", //报价id,
      supQuoteId: "", //供应商报价ID
      noticeStatus: "",
      purchaseType: "", //区分方案类型
      spanWidth: 200,
      btnDisabled: false,
      supCode: sessionStorage.getItem("supCode"),
      unit: "",
      endTimeSet: new Date(),
      endTimeserver: new Date(),
      timer4: null,
      isPassFlag: false, //1：通过 0或者空：淘汰
      tableBidFlag: true,
      allLoading: false
    };
  },
  methods: {
    //判断是否购买标书
    getSupTender() {
      let that = this;
      let param = {};
      Object.assign(
        param,
        { schemeId: this.schemeId },
        { agentId: this.agentId },
        { supCode: this.supCode },
        { isShowPageLoading: true }
      );
      qrySupTender(param).then(res => {
        if (res) {
          let sscSupPackTenderBOS = res.data.data.sscSupPackTenderBOS;
          if (sscSupPackTenderBOS && sscSupPackTenderBOS.length) {
            let newArr = sscSupPackTenderBOS.filter(e => e.buyFlag == 1);
            if (newArr.length === 0) {
              //因未按要求购买标书，无法参加投标及后续环节   提示
              this.$alert(
                window.$t("page.content.msgTip"),
                window.$t("page.content.tip"),
                {
                  showClose: false,
                  dangerouslyUseHTMLString: true,
                  type: "error",
                  beforeClose(action, instance, done) {
                    that.$router.go(-1);
                    done();
                  }
                }
              );
            }
          }
        }
      });
    },
    // 状态查询
    getState() {
      let obj = {
        isShowexeTime: false,
        isShowTag: false,
        isShowLeftTime: false,
        isShowCouTime: false
      };
      this.$store.commit("edit", obj);
      let param = {};
      Object.assign(
        param,
        { schemeId: this.schemeId },
        { agentId: this.agentId },
        { purStep: this.$route_query.purStep },
        { isShowPageLoading: true }
      );
      qryBidSchemeProcessStatus(param).then(res => {
        if (res) {
          this.flag = res.data.data.exeStatus;
          // this.flag = 3;
          if (this.flag == 1 || this.flag == 3) {
            this.queryPurchaseSchemeDetail();
          }
          this.bidStartTime = res.data.data.bidStartTime;
        }
      });
    },
    queryPurchaseSchemeDetail() {
      queryPurchaseSchemeDetail({
        schemeId: this.schemeId,
        agentId: this.agentId, //后期菜单获取
        isShowPageLoading: true
      }).then(res => {
        if (res) {
          this.purchaseType = res.data.data.purchaseType;
          this.unit = res.data.data.unit; //币种
          this.init();
        }
      });
    },
    init() {
      let param = {};
      Object.assign(
        param,
        { schemeId: this.schemeId },
        { supCode: this.supCode },
        //{ purStep: this.$route_query.purStep }, //后期菜单获取 有bug 固定6
        { purStep: "6" }, //2023.12.26改
        { agentId: this.agentId },
        { isShowPageLoading: true }
      );

      // 协议类
      if (this.purchaseType == 50 || this.purchaseType == 53) {
        qrySupBidDetailForFwa(param).then(res => {
          let obj = {
            leftTime: res.data.data.endTime,
            cutTime: res.data.data.endTime,
            leftName: this.$t("page.content.RemainingTime"), //投标剩余时间
            cutName: this.$t("page.content.Deadlineforsubmissionofbids"), //投标结束时间
            isShowexeTime: false,
            isShowTag: false,
            isShowLeftTime: false,
            isShowCouTime: false
          };
          this.bidPriceId = res.data.data.bidPriceId;
          this.supQuoteId = res.data.data.supQuoteId;
          this.bidFlag = res.data.data.bidFlag;
          this.projectText = res.data.data.projectText;
          if (res.data.data.endTime) {
            let vals = new Date(res.data.data.endTime.replace(/-/g, "/"));
            this.endTimeSet = vals;
            this.endTimeserver =
              this.UTCToLocalTimeString(res.headers.date) ||
              new Date().getTime();
            //var date2 = new Date(); //结束时间
            this.date3 = vals.getTime() - this.endTimeserver; //时间差的毫秒数
            if (this.date3 > 1000) {
              //this.date3 = Math.floor(this.date3 / 1000);
              this.timeId = setInterval(() => {
                this.date3 -= 1000;
                //console.log("date3===========",this.date3);
                this.date3 < 0 && clearInterval(this.timer4);
              }, 1000);
            } else {
              this.bidFlag = 5; //时间已结束 不能输入
            }
          }
          if (this.flag == 3 || this.bidFlag == 5) {
            obj.isShowLeftTime = true;
            obj.isShowCouTime = true;
          } else if (this.supQuoteId != "") {
            obj.isShowLeftTime = true;
            obj.isShowCouTime = true;
            obj.isShowTag = true;
            obj.TagName = this.$t("page.content.Submitted"); //已投标
          }
          this.$store.commit("edit", obj);
          this.tableUpData = res.data.data.sscPurchaseFileBOs;

          //投标中 && 非不能看 || 非结束状态  弹出未购买标书提示
          if (this.flag == 3 && (this.bidFlag != 2 || this.bidFlag != 5)) {
            this.getSupTender();
          }
        });
      } else {
        param.purchaseType = this.purchaseType;
        qrySupBidDetail(param).then(res => {
          if (res) {
            this.bidFlag = res.data.data.bidFlag;
            // this.bidFlag = 0;
            let sscSupBidPrepareBO = res.data.data.sscSupBidPrepareBO;
            //投标中 && 非不能看 || 非结束状态  弹出未购买标书提示
            if (
              sscSupBidPrepareBO == null &&
              this.flag == 3 &&
              (this.bidFlag != 2 || this.bidFlag != 5)
            ) {
              this.getSupTender();
            }
            this.bidPriceId = sscSupBidPrepareBO.bidPriceId;
            if (sscSupBidPrepareBO.endTime) {
              let vals = new Date(
                sscSupBidPrepareBO.endTime.replace(/-/g, "/")
              );
              this.endTimeSet = vals;
              this.endTimeserver =
                this.UTCToLocalTimeString(res.headers.date) ||
                new Date().getTime();
              //var date2 = new Date(); //结束时间
              this.date3 = vals.getTime() - this.endTimeserver; //时间差的毫秒数
              if (this.date3 > 1000) {
                //this.date3 = Math.floor(this.date3 / 1000);
                this.timeId = setInterval(() => {
                  this.date3 -= 1000;
                  //console.log("date3===========",this.date3);
                  this.date3 < 0 && clearInterval(this.timer4);
                }, 1000);
              } else {
                this.bidFlag = 5; //时间已结束 不能输入
              }
            }
            let obj = {
              leftTime: sscSupBidPrepareBO.endTime,
              cutTime: sscSupBidPrepareBO.endTime,
              leftName: this.$t("page.content.RemainingTime"), //投标剩余时间
              cutName: this.$t("page.content.Deadlineforsubmissionofbids"), //投标结束时间
              isShowexeTime: false,
              isShowTag: false,
              isShowLeftTime: false,
              isShowCouTime: false
            };
            if (this.flag == 3 || this.bidFlag == 5) {
              obj.isShowLeftTime = true;
              obj.isShowCouTime = true;
            }
            if (this.bidFlag == 1) {
              obj.isShowLeftTime = true;
              obj.isShowCouTime = true;
              obj.isShowTag = true;
              obj.TagName = this.$t("page.content.Submitted"); //已投标
            }
            this.$store.commit("edit", obj);
            if (res.data.data.sscBidPackMatInfoBOS.length > 0) {
              res.data.data.sscBidPackMatInfoBOS.forEach(i => {
                i["isBid"] = false;
                i.packBidTotalAmt =
                  i.packBidTotalAmt === ""
                    ? ""
                    : new BigNumber(i.packBidTotalAmt).toFormat(2);
                if (i.sscBidMatInfoBOS.length > 0) {
                  i.sscBidMatInfoBOS.forEach(ii => {
                    if (ii.comUnitPriceStr === "") {
                      ii.comUnitPrice = "";
                    } else {
                      ii.comUnitPrice =
                        ii.comUnitPrice === ""
                          ? ""
                          : ii.comUnitPrice.toFixed(2);
                    }
                    // ii.convPurchaseNum =
                    //   ii.convPurchaseNum == ""
                    //     ? ""
                    //     : ii.convPurchaseNum.toFixed(2);
                    ii.totalPrice =
                      ii.totalPrice === ""
                        ? ""
                        : new BigNumber(ii.totalPrice).toFormat(2);
                    if (ii.sscSupPriceItemBOS.length > 0) {
                      ii.sscSupPriceItemBOS.forEach(iii => {
                        if (iii.convPriceAmountStr === "") {
                          iii.convPriceAmount = "";
                        } else {
                          iii.convPriceAmount =
                            iii.convPriceAmount === ""
                              ? ""
                              : iii.convPriceAmount.toFixed(2);
                        }
                      });
                    }
                  });
                }
              });
            }
            if (this.bidFlag == 1 || this.subPackageFlag == 0) {
              if (this.subPackageFlag != 0) {
                res.data.data.sscBidPackMatInfoBOS.forEach(i => {
                  if (i.packBidTotalAmt === "") {
                    i.isBid = false;
                  } else {
                    i.isBid = true;
                  }
                });
              } else {
                res.data.data.sscBidPackMatInfoBOS.forEach(i => {
                  i.isBid = true;
                });
              }
              this.tableBid = res.data.data.sscBidPackMatInfoBOS;
            } else {
              res.data.data.sscBidPackMatInfoBOS.forEach(i => {
                i.isBid = false;
              });
              this.tableBid = res.data.data.sscBidPackMatInfoBOS;
            }
            this.tableUpData = res.data.data.sscPurchaseFileBOS;
          }
        });
      }
    },
    //提交
    submit() {
      this.btnDisabled = false;
      let tempFileData = JSON.parse(
        JSON.stringify(this.$refs.fileTable.fileData)
      );
      if (tempFileData.length == 0) {
        this.$message({
          message: this.$t("page.content.upload5"), //请上传投标文件
          type: "warning",
          duration: 3000,
          offset: document.documentElement.clientHeight / 2 - 21
        });
      } else {
        if (this.purchaseType != 50 && this.purchaseType != 53) {
          let tempTableData = [];
          let tempTableDataNo = []; //不报价的
          let tempTableData1 = JSON.parse(
            JSON.stringify(this.$refs.tableBid.tableData)
          );
          if (tempTableData1.length > 0) {
            tempTableData1.forEach(item => {
              // if (item.packStatus == "1") {
              if (item.isBid == true) {
                //判断是否报价
                tempTableData.push(item);
              } else {
                tempTableDataNo.push(item);
              }
              // }
            });
          }
          this.tableList = [];
          this.tableListNo = [];
          this.tableListNo = tempTableDataNo;
          // debugger
          if (tempTableData.length > 0) {
            tempTableData.forEach(item => {
              this.tableList.push(item);
            });
            //判断是否填写完整
            let flag = [];
            //let flag2 = []; //判断综合单价是否有负数
            if (this.tableList.length > 0) {
              this.tableList.forEach(item => {
                item.sscBidMatInfoBOS.forEach((ii, inx) => {
                  // if (Number(ii.comUnitPrice) < 0) {
                  //   flag2.push(ii.comUnitPrice);
                  // }
                  ii.sscSupPriceItemBOS.forEach((vv, index) => {
                    if (vv.convPriceAmount === "") {
                      //flag.push(vv.priceItem);
                      flag.push({
                        packName: item.packName,
                        column: vv.priceItem,
                        index: inx
                      });
                    }
                  });
                });
              });
            }
            //if (flag.length > 0 || flag2.length > 0) {
            if (flag.length > 0) {
              flag.forEach((item, index) => {
                if (index == 0) {
                  //包件
                  this.$message({
                    message:
                      (item.packName
                        ? `${window.$t("page.content.packageName")}${
                            item.packName
                          }-`
                        : "") +
                      `${window.$t("page.content.the")} ${item.index +
                        1} ${window.$t("page.content.line")}-${item.column}` +
                      this.$t("page.content.emptyTips"), //请将数据填写完整
                    type: "warning",
                    duration: 3000,
                    offset: document.documentElement.clientHeight / 2 - 21
                  });
                }
              });
              return false;
              // }
              // else {
              //   this.$message({
              //     message: `综合单价不能为负数，请重新输入！`, //请将数据填写完整
              //     type: "warning",
              //     duration: 3000,
              //     offset: document.documentElement.clientHeight / 2 - 21
              //   });
              //   return false;
              // }
            } else {
              //this.dialogTableVisibletextarea = true;
            }
          } else {
            this.$message({
              message: this.$t("page.content.leaseOne2"), //请将数据填写完整
              type: "warning",
              duration: 3000,
              offset: document.documentElement.clientHeight / 2 - 21
            });
            return false;
          }
          this.packNameList = this.tableList;
          this.total = 0;
          if (this.tableList.length > 0) {
            this.tableList.forEach(item => {
              this.total = window.$computeUtil.getPlusFormat(
                (this.total + "").replace(/,/g, ""),
                (item.packBidTotalAmt + "").replace(/,/g, "")
              );
            });
          }
          //金额超大提示
          if (
            new BigNumber(this.total.replace(/,/g, "")).toFixed(2) >
            999999999999.99
          ) {
            //投标总金额最大不能超过999,999,999,999.99
            this.$message({
              message: window.$t("page.content.totalBidAmount"), //请上传投标文件
              type: "warning",
              duration: 3000,
              offset: document.documentElement.clientHeight / 2 - 21
            });
            return false;
          } else {
            this.dialogTableVisibletextarea = true;
            this.totalCapitalize = this.smalltoBIG(
              this.total.replace(/,/g, "")
            );
          }
        } else {
          this.dialogTableVisibletextarea = true;
        }
      }
    },
    sure() {
      this.btnDisabled = true;
      if (this.date3 <= 0) {
        if (this.timeId) {
          clearInterval(this.timeId);
        }
        this.$confirm(
          this.$t("page.content.dialogTips3"),
          this.$t("page.content.tip"),
          {
            distinguishCancelAndClose: true,
            showCancelButton: false,
            confirmButtonText: this.$t("page.content.sure1"), //确定
            //取消
            customClass: "ccui-message-box-custom"
          }
        ).then(() => {
          this.getState();
        });
      } else {
        // 投标附件
        let FileInfoBOs = [];
        let fileinfoIds = [];
        let tempFileData = JSON.parse(
          JSON.stringify(this.$refs.fileTable.fileData)
        );

        tempFileData.forEach(item => {
          if (item.fileinfoId) {
            //fileinfoIds.push(item.fileinfoId);
            FileInfoBOs.push(item);
          } else {
            FileInfoBOs.push(item);
          }
        });
        //不是协议类
        if (this.purchaseType != 50 && this.purchaseType != 53) {
          let paramss = {};
          Object.assign(
            paramss,
            { schemeId: this.schemeId },
            { supCode: this.supCode },
            { purStep: this.$route_query.purStep }, //后期菜单获取
            { agentId: this.agentId }
          );
          paramss.isShowLoading = true;
          paramss.purchaseType = this.purchaseType;
          qrySupBidDetail(paramss).then(res => {
            if (res) {
              let priceStatus = res.data.data.sscSupBidPrepareBO.priceStatus;
              if (priceStatus == 3) {
                this.$confirm(
                  this.$t("page.content.dialogTips2"),
                  this.$t("page.content.tip"),
                  {
                    distinguishCancelAndClose: true,
                    showCancelButton: false,
                    confirmButtonText: this.$t("page.content.sure1"), //确定
                    //取消
                    customClass: "ccui-message-box-custom"
                  }
                ).then(() => {
                  this.$router.back();
                });
              } else {
                let param = {};
                let tableList1 = [];
                this.tableList.forEach(item => {
                  let obj = {};
                  obj.supJoinId = item.supJoinId;
                  obj.packId = item.packId;
                  obj.packName = item?.packName || "";
                  let sscBidMatPriceInfoBOS = [];
                  item.sscBidMatInfoBOS.forEach(aItem => {
                    aItem.sscSupPriceItemBOS.forEach(bItem => {
                      let sscSupPriceItemBO = {};
                      sscSupPriceItemBO.schemeMatId = aItem.schemeMatId;
                      sscSupPriceItemBO.bidPriceItemId = bItem.bidPriceItemId;
                      sscSupPriceItemBO.convPriceAmount = bItem.convPriceAmount;
                      sscBidMatPriceInfoBOS.push(sscSupPriceItemBO);
                    });
                  });
                  obj.sscBidMatPriceInfoBOS = sscBidMatPriceInfoBOS;
                  tableList1.push(obj);
                });
                this.tableListNo.forEach(item => {
                  let obj = {};
                  obj.supJoinId = item.supJoinId;
                  obj.packId = item.packId;
                  obj.packName = item?.packName || "";
                  let sscBidMatPriceInfoBOS = [];
                  item.sscBidMatInfoBOS.forEach(aItem => {
                    aItem.sscSupPriceItemBOS.forEach(bItem => {
                      let sscSupPriceItemBO = {};
                      sscSupPriceItemBO.schemeMatId = aItem.schemeMatId;
                      sscSupPriceItemBO.bidPriceItemId = bItem.bidPriceItemId;
                      sscSupPriceItemBO.convPriceAmount = null;
                      sscBidMatPriceInfoBOS.push(sscSupPriceItemBO);
                    });
                  });
                  obj.sscBidMatPriceInfoBOS = sscBidMatPriceInfoBOS;
                  tableList1.push(obj);
                });
                Object.assign(
                  param,
                  { schemeId: this.schemeId },
                  { supCode: this.supCode },
                  { purStep: this.$route_query.purStep }, //后期动态菜单后更换
                  { agentId: this.agentId },
                  { bidPriceId: this.bidPriceId },
                  { sscBidPackMatPriceInfoBOS: tableList1 },
                  { FileInfoBOs: FileInfoBOs },
                  { fileinfoIds: fileinfoIds }
                );
                //param.isShowLoading = true;
                this.allLoading = true;
                dealSupBidPrice(param)
                  .then(res => {
                    if (res) {
                      this.dialogTableVisibletextarea = false;
                      this.getState();

                      this.allLoading = false;
                      this.$message({
                        message: this.$t("page.content.successfully"), //投标成功
                        type: "success",
                        duration: 3000,
                        offset: document.documentElement.clientHeight / 2 - 21
                      });
                    }
                  })
                  .catch(() => {
                    this.allLoading = false;
                  });
              }
            }
          });
        }
        // 协议类
        else {
          let param = {};
          Object.assign(
            param,
            { schemeId: this.schemeId },
            { supCode: this.supCode },
            { purStep: this.$route_query.purStep }, //后期动态菜单后更换
            { agentId: this.agentId },
            { supQuoteId: this.supQuoteId },
            { bidPriceId: this.bidPriceId },
            { FileInfoBOs: FileInfoBOs },
            { fileinfoIds: fileinfoIds }
          );
          param.isShowLoading = true;
          dealSupBidPriceForFwa(param).then(res => {
            if (res) {
              this.dialogTableVisibletextarea = false;
              this.getState();
              this.$message({
                message: this.$t("page.content.successfully"), //投标成功
                type: "success",
                duration: 3000,
                offset: document.documentElement.clientHeight / 2 - 21
              });
            }
          });
        }
      }
    },
    //再次上报  重新渲染包件列表
    submmitAgain() {
      this.tableBidFlag = false;

      let param = {};
      Object.assign(
        param,
        { schemeId: this.schemeId },
        { supCode: this.supCode },
        { purStep: this.$route_query.purStep }, //后期菜单获取
        { agentId: this.agentId },
        { isShowLoading: true }
      );
      // 协议类
      if (this.purchaseType == 50 || this.purchaseType == 53) {
        qrySupBidDetailForFwa(param).then(res => {
          let obj = {
            leftTime: res.data.data.endTime,
            cutTime: res.data.data.endTime,
            leftName: this.$t("page.content.RemainingTime"), //投标剩余时间
            cutName: this.$t("page.content.Deadlineforsubmissionofbids"), //投标结束时间
            isShowexeTime: false,
            isShowTag: false,
            isShowLeftTime: false,
            isShowCouTime: false
          };
          this.bidPriceId = res.data.data.bidPriceId;
          this.supQuoteId = res.data.data.supQuoteId;
          this.bidFlag = res.data.data.bidFlag;
          this.projectText = res.data.data.projectText;
          if (res.data.data.endTime) {
            let vals = new Date(res.data.data.endTime.replace(/-/g, "/"));
            this.endTimeSet = vals;
            this.endTimeserver =
              this.UTCToLocalTimeString(res.headers.date) ||
              new Date().getTime();
            //var date2 = new Date(); //结束时间
            this.date3 = vals.getTime() - this.endTimeserver; //时间差的毫秒数
            if (this.date3 > 1000) {
              //this.date3 = Math.floor(this.date3 / 1000);
              this.timeId = setInterval(() => {
                this.date3 -= 1000;
                //console.log("date3===========",this.date3);
                this.date3 < 0 && clearInterval(this.timer4);
              }, 1000);
            } else {
              this.bidFlag = 5; //时间已结束 不能输入
            }
          }
          if (this.flag == 3 || this.bidFlag == 5) {
            obj.isShowLeftTime = true;
            obj.isShowCouTime = true;
          } else if (this.supQuoteId != "") {
            obj.isShowLeftTime = true;
            obj.isShowCouTime = true;
            obj.isShowTag = true;
            obj.TagName = this.$t("page.content.Submitted"); //已投标
          }
          this.$store.commit("edit", obj);
          this.tableUpData = res.data.data.sscPurchaseFileBOs;

          this.bidFlag = 0; //重新填写 关键代码
          this.btnDisabled = false;
        });
      } else {
        param.purchaseType = this.purchaseType;
        qrySupBidDetail(param).then(res => {
          if (res) {
            this.bidFlag = res.data.data.bidFlag;
            // this.bidFlag = 0;
            let sscSupBidPrepareBO = res.data.data.sscSupBidPrepareBO;
            this.bidPriceId = sscSupBidPrepareBO.bidPriceId;
            if (sscSupBidPrepareBO.endTime) {
              let vals = new Date(
                sscSupBidPrepareBO.endTime.replace(/-/g, "/")
              );
              this.endTimeSet = vals;
              this.endTimeserver =
                this.UTCToLocalTimeString(res.headers.date) ||
                new Date().getTime();
              //var date2 = new Date(); //结束时间
              this.date3 = vals.getTime() - this.endTimeserver; //时间差的毫秒数
              if (this.date3 > 1000) {
                //this.date3 = Math.floor(this.date3 / 1000);
                this.timeId = setInterval(() => {
                  this.date3 -= 1000;
                  //console.log("date3===========",this.date3);
                  this.date3 < 0 && clearInterval(this.timer4);
                }, 1000);
              } else {
                this.bidFlag = 5; //时间已结束 不能输入
              }
            }
            let obj = {
              leftTime: sscSupBidPrepareBO.endTime,
              cutTime: sscSupBidPrepareBO.endTime,
              leftName: this.$t("page.content.RemainingTime"), //投标剩余时间
              cutName: this.$t("page.content.Deadlineforsubmissionofbids"), //投标结束时间
              isShowexeTime: false,
              isShowTag: false,
              isShowLeftTime: false,
              isShowCouTime: false
            };
            if (this.flag == 3 || this.bidFlag == 5) {
              obj.isShowLeftTime = true;
              obj.isShowCouTime = true;
            }
            if (this.bidFlag == 1) {
              obj.isShowLeftTime = true;
              obj.isShowCouTime = true;
              obj.isShowTag = true;
              obj.TagName = this.$t("page.content.Submitted"); //已投标
            }
            this.$store.commit("edit", obj);
            if (res.data.data.sscBidPackMatInfoBOS.length > 0) {
              res.data.data.sscBidPackMatInfoBOS.forEach(i => {
                i["isBid"] = false;
                i.packBidTotalAmt =
                  i.packBidTotalAmt === ""
                    ? ""
                    : new BigNumber(i.packBidTotalAmt).toFormat(2);
                if (i.sscBidMatInfoBOS.length > 0) {
                  i.sscBidMatInfoBOS.forEach(ii => {
                    if (ii.comUnitPriceStr === "") {
                      ii.comUnitPrice = "";
                    } else {
                      ii.comUnitPrice =
                        ii.comUnitPrice === ""
                          ? ""
                          : ii.comUnitPrice.toFixed(2);
                    }
                    // ii.convPurchaseNum =
                    //   ii.convPurchaseNum == ""
                    //     ? ""
                    //     : ii.convPurchaseNum.toFixed(2);
                    ii.totalPrice =
                      ii.totalPrice === ""
                        ? ""
                        : new BigNumber(ii.totalPrice).toFormat(2);
                    if (ii.sscSupPriceItemBOS.length > 0) {
                      ii.sscSupPriceItemBOS.forEach(iii => {
                        if (iii.convPriceAmountStr === "") {
                          iii.convPriceAmount = "";
                        } else {
                          iii.convPriceAmount =
                            iii.convPriceAmount === ""
                              ? ""
                              : iii.convPriceAmount.toFixed(2);
                        }
                      });
                    }
                  });
                }
              });
            }
            if (this.bidFlag == 1 || this.subPackageFlag == 0) {
              if (this.subPackageFlag != 0) {
                res.data.data.sscBidPackMatInfoBOS.forEach(i => {
                  if (i.packBidTotalAmt === "") {
                    i.isBid = false;
                  } else {
                    i.isBid = true;
                  }
                });
              } else {
                res.data.data.sscBidPackMatInfoBOS.forEach(i => {
                  i.isBid = true;
                });
              }
              this.tableBid = res.data.data.sscBidPackMatInfoBOS;
            } else {
              res.data.data.sscBidPackMatInfoBOS.forEach(i => {
                i.isBid = false;
              });
              this.tableBid = res.data.data.sscBidPackMatInfoBOS;
            }
            this.tableUpData = res.data.data.sscPurchaseFileBOS;
          }
          this.tableBidFlag = true;

          this.bidFlag = 0; //重新填写 关键代码
          this.btnDisabled = false;
        });
      }
    },
    cacal() {
      let param = {};
      Object.assign(
        param,
        { schemeId: this.schemeId },
        { supCode: this.supCode },
        { purStep: this.$route_query.purStep }, //后期动态菜单后更换
        { agentId: this.agentId },
        { bidPriceId: this.bidPriceId }
      );
      // 您是否确认撤销投标 -------   撤销投标
      this.$confirm(
        this.$t("page.content.withdraw"),
        this.$t("page.content.WithdrawofBid"),
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$t("page.content.sure1"), //确定
          cancelButtonText: this.$t("page.content.cancel"), //取消
          customClass: "ccui-message-box-custom"
        }
      ).then(() => {
        dealSupBidPriceCancel(param).then(res => {
          if (res) {
            this.getState();
            this.$message({
              message: this.$t("page.content.withdraw1"), //撤销成功
              type: "success",
              duration: 3000,
              offset: document.documentElement.clientHeight / 2 - 21
            });

            //撤销成功 刷新页面
            this.reload(); // 在其他页面需要的地方直接调用即可
          }
        });
      });
    },
    handleCacal() {
      this.getState();
    },
    /** 数字金额大写转换(可以处理整数,小数,负数) */
    UTCToLocalTimeString(d) {
      let date = new Date(d);
      let timeOffsetInHours = new Date().getTimezoneOffset() / 60 + 8; //这里的 8是时区，东八区为北京时间，PS：东区为正数 西区为负数
      date.setHours(date.getHours() + timeOffsetInHours);
      console.log(date, "这是转东八区后的d", date.getTime());
      return date.getTime();
    },
    getCurrentDate() {
      getSystemCurrentTime({}).then(res => {
        this.endTimeserver =
          this.UTCToLocalTimeString(res.headers.date) || new Date().getTime();
        this.date3 = this.endTimeSet.getTime() - this.endTimeserver; //时间差的毫秒数
        // console.log("=======date3===========",this.date3);
        // console.log("endTimeserver===========",this.endTimeserver);
        // console.log("endTimeSet===========",this.endTimeSet.getTime());
        if (this.date3 < 0) {
          clearInterval(this.timer4);
        }
      });
    },
    smalltoBIG(n) {
      var fraction = ["角", "分"];
      var digit = ["零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"];
      var unit = [
        ["元", "万", "亿"],
        ["", "拾", "佰", "仟"]
      ];
      var head = n < 0 ? "负" : "";
      n = Math.abs(n);

      var s = "";

      for (var i = 0; i < fraction.length; i++) {
        s += (
          digit[
            Math.floor(
              window.$computeUtil.getMultiply(n, 10, Math.pow(10, i))
            ) % 10
          ] + fraction[i]
        ).replace(/零./, "");
      }
      s = s || "整";
      n = Math.floor(n);

      for (var k = 0; k < unit[0].length && n > 0; k++) {
        var p = "";
        for (var j = 0; j < unit[1].length && n > 0; j++) {
          p = digit[n % 10] + unit[1][j] + p;
          n = Math.floor(n / 10);
        }
        s = p.replace(/(零.)*零$/, "").replace(/^$/, "零") + unit[0][k] + s;
      }
      return (
        head +
        s
          .replace(/(零.)*零元/, "元")
          .replace(/(零.)+/g, "零")
          .replace(/^整$/, "零元整")
      );
    }
    /*smalltoBIG(money) {
      var cnNums = new Array("零","壹","贰","叁","肆","伍","陆","柒","捌","玖"); //汉字的数字
      var cnIntRadice = new Array("","拾","佰","仟"); //基本单位
      var cnIntUnits = new Array("","万","亿","兆"); //对应整数部分扩展单位
      var cnDecUnits = new Array("角","分","毫","厘"); //对应小数部分单位
      //var cnInteger = "整"; //整数金额时后面跟的字符
      var cnIntLast = "元"; //整型完以后的单位
      var maxNum = 999999999999999.9999; //最大处理的数字

      var IntegerNum; //金额整数部分
      var DecimalNum; //金额小数部分
      var ChineseStr=""; //输出的中文金额字符串
      var parts; //分离金额后用的数组，预定义
      if( money == "" ){
        return "";
      }
      money = parseFloat(money);
      if( money >= maxNum ){
        console.log('超出最大处理数字');
        return "";
      }
      if( money == 0 ){
        //ChineseStr = cnNums[0]+cnIntLast+cnInteger;
        ChineseStr = cnNums[0]+cnIntLast
        //document.getElementById("show").value=ChineseStr;
        return ChineseStr;
      }
      money = money.toString(); //转换为字符串
      if( money.indexOf(".") == -1 ){
        IntegerNum = money;
        DecimalNum = '';
      }else{
        parts = money.split(".");
        IntegerNum = parts[0];
        DecimalNum = parts[1].substr(0,4);
      }
      if( parseInt(IntegerNum,10) > 0 ){//获取整型部分转换
        let zeroCount = 0;
        let IntLen = IntegerNum.length;
        for(let i=0;i<IntLen;i++ ){
          let n = IntegerNum.substr(i,1);
          let p = IntLen - i - 1;
          let q = p / 4;
          let m = p % 4;
          if( n == "0" ){
            zeroCount++;
          }else{
            if( zeroCount > 0 ){
              ChineseStr += cnNums[0];
            }
            zeroCount = 0; //归零
            ChineseStr += cnNums[parseInt(n)]+cnIntRadice[m];
          }
          if( m==0 && zeroCount<4 ){
            ChineseStr += cnIntUnits[q];
          }
        }
        ChineseStr += cnIntLast;
        //整型部分处理完毕
      }
      if( DecimalNum!= '' ){//小数部分
        let decLen = DecimalNum.length;
        for(let i=0; i<decLen; i++ ){
          let n = DecimalNum.substr(i,1);
          if( n != '0' ){
            ChineseStr += cnNums[Number(n)]+cnDecUnits[i];
          }
        }
      }
      if( ChineseStr == '' ){
        //ChineseStr += cnNums[0]+cnIntLast+cnInteger;
        ChineseStr += cnNums[0]+cnIntLast;
      }/!* else if( DecimalNum == '' ){
                ChineseStr += cnInteger;
                ChineseStr += cnInteger;
            } *!/
      return ChineseStr;
    }*/
  },
  computed: {},
  destroyed() {
    let bidHeadInfo = {
      leftTime: "0天12小时06分",
      cutTime: "2021-12-15 15:00",
      leftName: "",
      cutName: "",
      TagName: "",
      isShowexeTime: true,
      isShowTag: false,
      isShowLeftTime: false,
      isShowCouTime: false
    };
    this.$store.commit("edit", bidHeadInfo);

    this.timer4 && clearInterval(this.timer4);
  }
};
</script>

<style lang="scss" scoped>
.noBegin {
  display: flex;
  justify-content: center;
  height: 500px;
  align-items: center;
  font-size: 18px;
  color: #4a4a4a;
}

.noBuy {
  .el-alert--info.is-light {
    color: #0089ef;
    background-color: #e6f7ff;
  }
}
.upFile {
  margin-top: 15px;
  position: relative;
  span {
    position: absolute;
    top: 0px;
    left: 100px;
    color: #999999;
  }
}
.dialogBid {
  width: 420px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .item-packName {
    max-width: 230px;
  }
  p {
    line-height: 25px;
  }
}
.tableDownload {
  padding: 15px 0;
}
.operate {
  position: fixed;
  width: calc(100% - 270px);
  bottom: 20px;
  height: 40px;
  z-index: 999;
  background: rgba(76, 76, 76, 0.8);
  text-align: center;
  .el-button {
    color: white;
  }
}
</style>
